import React from "react";
import Sale from "./sale";
import AIBuilderAdapter from "./ai-builder";
import HelmetLayout from "../../components/HelmetLayout";

export default function Settings() {
  return (
    <>
      <HelmetLayout title="Settings" />
      <div className="space-y-8 pb-16 max-w-5xl">
        {/* Header Section */}
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Settings</h1>
          <p className="text-slate-500 text-sm mt-0.5">
            Configure system promotional sales, plan addons, and AI builder agent adapters.
          </p>
        </div>

        {/* Sales & Addons Card */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <Sale />
        </div>

        {/* AI Builder Configuration Card */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <AIBuilderAdapter />
        </div>
      </div>
    </>
  );
}